(function (Drupal, $) {
  Drupal.behaviors.customSlider = {
    attach: function (context, settings) {
      $(once('customSlider', '.videos-slider', context)).each(function () {
        $(this).slick({
          dots: true,
          infinite: true,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerPadding: "0",
          centerMode: true,
          arrows: true,
          responsive: [{
            breakpoint: 768,
            settings: {
              centerMode: false,
              centerPadding: "20px",
              slidesToShow: 1,
              arrows: true
            }
          }]
        });
      });

      $(context).find('.videos-slider').on("click", ".slick-arrow", function(e) {
        e.stopPropagation();
        var e = $(".videos-slider .slick-dots li.slick-active"),
          t = $(".videos-slider .slick-dots li"),
          a = e.find("button").attr("aria-label");
        changeSlickDots(e, a, t);
      });

      $(context).find('.videos-slider').on("click", ".slick-slide:not(.slick-current)", function(e) {
        e.stopPropagation();
        var e = $(this).data("slick-index");
        $(".slick-slider").slick("slickGoTo", e);
        var e = $(".videos-slider .slick-dots li.slick-active"),
          t = $(".videos-slider .slick-dots li"),
          a = e.find("button").attr("aria-label");
        changeSlickDots(e, a, t);
      });

      if ($(".videos-slider .slick-dots li.slick-active").length === 1) {
        var o = $(".videos-slider .slick-dots li.slick-active");
        $(".videos-slider .slick-dots li").removeClass("visible-dots");
        o.addClass("visible-dots");
        o.prev().addClass("visible-dots");
        var next = o.next();
        next.addClass("visible-dots");
        next.next().addClass("visible-dots");
      }

      $(context).find('.videos-slider').on("swipe", function(e, t, a) {
        var i = $(".videos-slider .slick-dots li.slick-active"),
          o = $(".videos-slider .slick-dots li"),
          s = i.find("button").attr("aria-label");
        changeSlickDots(i, s, o);
      });

      $("body", context).on("click", ".videos-slider .slick-dots li button", function(e) {
        changeSlickDots($(this).parent("li"), $(this).attr("aria-label"), $(".videos-slider .slick-dots li"));
      });
    }
  };

  function changeSlickDots(activeDot, label, allDots) {
    allDots.removeClass("visible-dots");
    activeDot.addClass("visible-dots");
    var index;
    allDots.each(function (i) {
      if ($(this).hasClass('slick-active')) {
        index = i;
        return false;
      }
    });

    var visible = [];
    if (index === 0) {
      visible.push(1);
      visible.push(2);
    }
    else if (index === (allDots.length - 1)) {
      visible.push(index - 1);
      visible.push(index - 2);
    }
    else {
      visible.push(index - 1);
      visible.push(index + 1);
    }

    visible.forEach(function (item) {
      if (allDots[item]) {
        $(allDots[item]).addClass("visible-dots");
      }
    })
  }

  Drupal.behaviors.videoSliderPopupTriger = {
    attach: function (context, settings) {
      $(once('videoSliderPopupTriger', '.videos-block .image-wrapper', context)).each(function () {

        var openPopup = function (block) {
          block.parents('.videos-block').find('.video-embed-field-launch-modal').trigger('click');
        }
        $(this).on('click', function (e) {
          e.preventDefault();
          openPopup($(this));
        })

        var isAccessible = sessionStorage.getItem('access');
        var fragment = window.location.hash;
        var modalWelcome = $('.modal-welcome');
        var $this = $(this)
        if (fragment && ('#' + $this.attr('id')) === fragment) {
          if (isAccessible) {
            openPopup($this);
          } else {
            modalWelcome.find('.modal-close').on('click', function () {
              openPopup($this);

            })
            modalWelcome.find('.continue').on('click', function () {
              openPopup($this);
            })
          }
        }
      });
    }
  };
})(Drupal, jQuery);
